import Dropzone from 'dropzone';

if (document.querySelector("#js-my-form-rich")) {
  let myDropzone = new Dropzone('.p-form--dropzoon', {
    paramName: "file",
    url: "/",
    maxFilesize: 1,
    createImageThumbnails: true,
    addRemoveLinks: true,
    dictRemoveFile: "",
    accept: function (file: any, done: any) {
      if (file.name == 'sa') {
        done('aa');
      } else {
        done();
      }
    },
  });

  const CheckDefault = () => {
    let addElm: NodeList = document.querySelectorAll('.dz-preview');
    let dropDefault: HTMLElement | null = document.querySelector(
      '.p-form--dropzoon__normal'
    );
    console.log(addElm.length);
    if (dropDefault) {
      if (addElm.length > 0) {
        dropDefault.classList.add('p-form--dropzoon__normal--remove');
      } else {
        dropDefault.classList.remove('p-form--dropzoon__normal--remove');
      }
    }
  }

  myDropzone.on('addedfile', () => {
    CheckDefault();
  });

  myDropzone.on('removedfile', () => {
    CheckDefault();
  })
}


